import { fetchMySettings } from "./api";
import type { SettingsModel } from "./schema";

const RESYNC_MIN_INTERVAL_MS = 60_000;
let lastSync = 0;

/** Apply the saved accent/background to <html> and the local cache that main.tsx reads at startup. */
function applyAppearance(appearance: Partial<SettingsModel["appearance"]> | undefined) {
  if (!appearance) return;
  try {
    const root = document.documentElement;
    const { accent, background } = appearance;
    if (typeof accent === "string" && accent && root.getAttribute("data-theme") !== accent) {
      root.setAttribute("data-theme", accent);
      localStorage.setItem("theme", accent);
      window.dispatchEvent(new CustomEvent("echo:accentChange", { detail: accent }));
    }
    if (typeof background === "string" && background && root.getAttribute("data-bg") !== background) {
      root.setAttribute("data-bg", background);
      localStorage.setItem("bg", background);
    }
  } catch {
    // best-effort; startup defaults still apply
  }
}

/** Pull the account's settings from the server and apply them, so choices follow the user across devices. */
export async function syncAppearanceFromServer(force = false) {
  const now = Date.now();
  if (!force && now - lastSync < RESYNC_MIN_INTERVAL_MS) return;
  lastSync = now;
  const settings = await fetchMySettings();
  applyAppearance(settings.appearance);
}
